<template>
    <DsMenu
        align="end"
        avoidCollisions
    >
        <template #menuTrigger>
            <DsButton
                leading="fa-regular fa-columns-3"
                size="sm"
                variant="secondary"
            >
                Column visibility
            </DsButton>
        </template>

        <DsMenuGroup :label="`Customize columns (${visibleColumns.length} of ${columns.length} visible)`">
            <div class="flex flex-col space-y-3 p-3">
                <DsCheckbox
                    v-for="column in alwaysVisibleColumns"
                    v-model="visibleFields"
                    :key="column.field"
                    disabled
                    :inputId="`column-${column.field}`"
                    :label="column.header"
                    name="visible-columns"
                    :value="column.field"
                />
            </div>
        </DsMenuGroup>

        <DsMenuGroup>
            <div class="flex flex-col space-y-3 p-3">
                <DsCheckbox
                    v-for="column in toggleableColumns"
                    v-model="visibleFields"
                    :key="column.field"
                    :inputId="`column-${column.field}`"
                    :label="column.header"
                    name="visible-columns"
                    :value="column.field"
                />
            </div>
        </DsMenuGroup>
    </DsMenu>
</template>

<script setup lang="ts">
import type { FileTableColumn, FileTableColumnField } from '@/components/Views/Company/File/file-table.types';
import DsButton from '@ds/button/DsButton.vue';
import DsCheckbox from '@ds/form/input/DsCheckbox.vue';
import DsMenu from '@ds/menu/DsMenu.vue';
import DsMenuGroup from '@ds/menu/DsMenuGroup.vue';
import { computed } from 'vue';

const ALWAYS_VISIBLE_FIELDS: readonly FileTableColumn['field'][] = ['ref_number', 'address'];

const props = defineProps<{ columns: readonly FileTableColumn[]; visibleColumns: FileTableColumn[] }>();

const visibleFields = defineModel<FileTableColumnField[]>({ required: true });

const alwaysVisibleColumns = computed(() => props.columns.filter(column => ALWAYS_VISIBLE_FIELDS.includes(column.field)));

const toggleableColumns = computed(() => props.columns.filter(column => !ALWAYS_VISIBLE_FIELDS.includes(column.field)));
</script>
